import React, { useState } from 'react';
import ModalComponent from '@components/Modal/ModalComponent';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Add from './Add';
import Update from './Update';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import useGetCashBoxesList from '@hooks/Finance/CashBoxes/useGetCashBoxesList';
import NtxTable from '@components/DataTable/NtxTable';

const Index = () => {
  const [ID, setID] = useState<string>('');

  const [Show, setShow] = useState(false);

  const { t, i18n } = useTranslation();

  const { CashBoxesList, loading, error } = useGetCashBoxesList();

  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('Account'), key: 'Account' },
    { title: t('وحدة التشغيل'), key: 'organizationName' },

    { title: '', key: 'action', className: 'text-end' }
  ];

  const tableData =
    CashBoxesList?.map(item => {
      let rowClass;

      return {
        name: i18n.language === 'en' ? item.name : item.name2,
        Account: i18n.language === 'en' ? item.ntxBankName : item.ntxBankName2,
        organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,

        action: (
          <>
            {' '}
            <button
              type='button'
              className='btn btn-sm btn-outline-theme ms-1'
              data-bs-toggle='modal'
              data-bs-target='#modalEdit'
              onClick={() => setID(item.id)}
            >
              <i className='far fa-lg fa-fw fa-edit me-1'></i>
              {t('Button.Edit')}
            </button>
          </>
        )
      };
    }) || [];

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'CashBoxes',
              link: null
            }
          ]}
          PageName='CashBoxes'
        />

        <div className='ms-auto'>
          <Link
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAdd'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewCashBox')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns || []}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch={true}
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddCashBox')} id='modalAdd' size='lg'>
        {Show && <Add />}
      </ModalComponent>

      <ModalComponent title={t('EditCashBox')} id='modalEdit' size='lg'>
        {ID && <Update ID={ID} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
